var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408.8 408.8",
    style: {
      enableBackground: "new 0 0 408.8 408.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C99E79"
    },
    points: "176.8,291.6 204.4,208 34.4,107.2 5.6,191.2 91.2,241.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#643513"
    },
    points: "204.4,7.2 290,57.2 375.2,107.6 290,157.6 203.6,208.4 118.8,157.6 33.6,107.6 118.8,57.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#926E43"
    },
    points: "203.6,208.4 203.6,403.6 33.6,305.2 33.6,207.6 91.2,241.2 176.8,291.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9AC80"
    },
    points: "33.6,107.6 0,105.2 171.2,5.2 204.4,7.2 118.8,57.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67E4F"
    },
    d: "M375.2,113.2v-5.6l-1.6,0.8L375.2,113.2z M203.6,208.4v195.2l170-98.4l0.8-98.4l-58.8,34.4 L230,291.6L203.6,208.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9AC80"
    },
    points: "230,291.6 203.6,208.4 373.6,107.6 401.2,191.2 315.6,241.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9AC80"
    },
    points: "375.2,107.6 408.8,105.2 237.6,5.2 204.4,7.2 290,57.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8D5122"
    },
    points: "204.4,140.4 204.4,7.2 118.8,57.2 33.6,107.6 118.8,157.6 146.4,174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77411B"
    },
    points: "204.4,7.2 204.4,140.4 262,173.6 373.6,107.6 373.6,108.4 375.2,107.6 290,57.2  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpen);
export default __webpack_public_path__ + "static/media/box-open.0b9df9e7bd3158184e6bc61086cd3aa7.svg";
export { ForwardRef as ReactComponent };